import {
    useClientPublicCandidateHandlers,
} from "./candidate/clientPublicCandidateHandlers";
import {
    useClientPublicCandidateErrorHandlers,
} from "./clientPublicCandidateErrorHandlers";
import { ClientPublicCandidateState } from "./clientPublicCandidateState";
import {
    CombinedClientPublicCandidateActions,
} from "./combinedClientPublicCandidateActions";

export const useCombinedClientPublicCandidateHandlers = (
    state: ClientPublicCandidateState,
    actions: CombinedClientPublicCandidateActions
) => {
    useClientPublicCandidateErrorHandlers(state, actions);
    useClientPublicCandidateHandlers(state, actions);
};
